module.exports = __webpack_public_path__ + "static/img/icon-ens-item2.3771258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-ens-item2.png
// module id = 5Kve
// module chunks = 21